<div class="list-wrapper">
  @for (ganarbol of ganarbols; track ganarbol) {
    <div class="item" (click)="onGanarbolClick(ganarbol)">
      <div class="left-side">
        <!-- TODO: use app-user-avatar -->
        <nz-avatar [nzSize]="40" [nzSrc]="ganarbol?.avatarUrl"></nz-avatar>
        <div class="user-info">
          <span class="paragraph-medium regular">{{ ganarbol.fullName }}</span>
          <span class="paragraph-small regular">{{ ganarbol.leaves }} {{ 'myGanarbols.leaves' | translate }}</span>
        </div>
      </div>
      <div class="right-side">
        <i nz-icon>
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path
              d="M5.64644 13.1868C5.45118 12.9915 5.45118 12.675 5.64644 12.4797L10.1262 7.99992L5.64644 3.52012C5.45118 3.32485 5.45118 3.00832 5.64644 2.81305C5.8417 2.61779 6.15829 2.61779 6.35355 2.81305L11.1869 7.64639C11.3821 7.84165 11.3821 8.15819 11.1869 8.35345L6.35355 13.1868C6.15829 13.3821 5.84171 13.3821 5.64644 13.1868Z"
              fill="#505760"
            />
          </svg>
        </i>
      </div>
    </div>
  }
</div>
